export default __webpack_public_path__ + "static/media/60t.c29e72df.jpg";